import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="countdown"
export default class extends Controller {
  static targets = ["timer"];
  static values = { endAt: String };

  connect() {
    // Convert the Rails timezone string to a JS timestamp
    this.endTime = new Date(this.endAtValue).getTime();

    // Run immediately so there is no 1-second delay flash
    this.updateTimer();

    // Tick every 1000ms
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  disconnect() {
    clearInterval(this.timerInterval);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endTime - now;

    // If time is up, lock it at 00:00 and flash red
    if (distance < 0) {
      clearInterval(this.timerInterval);
      this.timerTarget.textContent = "ENDED";
      this.timerTarget.classList.add("text-red-600", "animate-pulse");
      return;
    }

    // Math for hours, minutes, and seconds
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Pad with leading zeros (e.g., 5 -> "05")
    const fHours = hours.toString().padStart(2, "0");
    const fMinutes = minutes.toString().padStart(2, "0");
    const fSeconds = seconds.toString().padStart(2, "0");

    // Display format
    if (hours > 0) {
      this.timerTarget.textContent = `${fHours}:${fMinutes}:${fSeconds}`;
    } else {
      this.timerTarget.textContent = `${fMinutes}:${fSeconds}`;

      // HYPE TRIGGER: Turn red and pulse if under 5 minutes!
      if (minutes < 5) {
        this.timerTarget.classList.add("text-red-500", "animate-pulse");
      }
    }
  }
}
